import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../../Defaults/Text';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';

import {
  getCartItemData,
  getCartItemInfo,
} from '../../../../utilities/selectors';
import {
  formatPrice,
  getSymbolFromCurrency,
  prop,
} from '../../../../utilities';
import { __ } from 'react-i18n';
import { CountSetter } from '../../Product/CountSetter';
import { DsiSvgIcon, IconType } from '../../General/SvgIcon';
export interface Props {
  item: any;
  handleRemoveClick: any;
  handleCountChange: any;
  isActionSale?: boolean;
  theme: any;
}

function MiniCartItem({
  item,
  handleRemoveClick,
  handleCountChange,
  isActionSale,
  theme,
}: Props) {
  const {
    picture,
    url,
    name,
    price,
    currency,
    attrib,
    count: initialCount,
  } = getCartItemData(item);
  const { productId, goodId, units } = getCartItemInfo(item);

  const [count, setCount] = React.useState(initialCount);

  const countChange = (newCount: string) => {
    let newCountNumber = parseFloat(newCount);

    newCountNumber = parseFloat(newCount);
    const countDiff = -(+initialCount - +newCountNumber);
    handleCountChange(item, countDiff);
    setCount(newCount);
  };

  const handleDelete = () => {
    handleRemoveClick(productId, goodId);
  };

  const isActionSaleProps = isActionSale;
  const isSaleFree = prop(item, 'sale_info.is_free');
  isActionSale = isActionSale || isSaleFree;

  return (
    <Wrapper>
      <ImageNameWrapper>
        <Link to={url}>
          <Image alt={`${__('Obrázok ku produktu')} ${name}`} src={picture} />
        </Link>
        <ContentWrapper>
          <NameWrapper to={url}>
            <Name>{name}</Name>
            <Price>
              {isActionSale
                ? item.sale_price
                  ? formatPrice(item.sale_price, item.sale_currency)
                  : __('Zadarmo')
                : `${price ? price.toFixed(2) : 0} ${getSymbolFromCurrency(
                    currency,
                  )}`}
            </Price>
          </NameWrapper>
          <HelpText>{attrib}</HelpText>
        </ContentWrapper>
        <CountSetterWrapper>
          {isActionSale ? (
            <ActionSaleCount>{`${
              isActionSaleProps
                ? prop(item, 'sale_count') || 1
                : prop(item, 'count')
            } ${units}`}</ActionSaleCount>
          ) : (
            <CountSetter count={count} onChange={countChange} />
          )}
        </CountSetterWrapper>
        {/* <StyledButton onClick={handleRemoveClick}> */}
        {isActionSale ? (
          <DsiSvgIcon
            icon={IconType.percentage}
            width={16}
            height={16}
            fill={theme.colors.primary}
            title={__('Akcia')}
          />
        ) : (
          <DsiSvgIcon
            cursor={'pointer'}
            icon={IconType.trash}
            width={16}
            height={16}
            fill={'#cccccc'}
            onClick={handleDelete}
          />
        )}
        {/* </StyledButton> */}
      </ImageNameWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  margin-bottom: ${rem(24)};
  justify-content: space-between;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ImageNameWrapper = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  width: 100%;
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;

  ${({ theme }) => theme.mediab.l1150`
    margin-right: ${rem(8)};
  `}
`;

const Image = styled.img`
  width: ${rem(48)};
  max-height: ${rem(48)};
  height: auto;
  margin-right: ${rem(16)};
`;

const NameWrapper = styled(Link)`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  text-decoration: none;
`;

const ContentWrapper = styled(FlexCol)`
  flex: 1;
`;

const CountSetterWrapper = styled.div`
  max-width: ${rem(100)};
  width: 100%;
  margin-right: ${rem(16)};
`;

const Name = styled(TextP)`
  font-size: ${rem(16)};
  line-height: ${rem(18)};
  text-decoration: none;
  color: ${({ theme }) => theme.color.textPrimary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${rem(150)};
  margin-bottom: ${rem(4)};

  ${({ theme }) => theme.mediab.s450`
    max-width: ${rem(130)};
  `}
`;

const HelpText = styled(Name)`
  font-size: ${rem(13)};
  color: ${({ theme }) => theme.color.gray48};
  margin-top: ${rem(2)};
`;

const Price = styled(TextP)`
  font-size: ${rem(16)};
  font-weight: 500;
  line-height: ${rem(18)};
  color: ${({ theme }) => theme.color.textPrimary};
  white-space: nowrap;
`;

const HighlightedText = styled.span`
  background-color: ${({ theme }) => theme.colors.highlight};
`;

const ActionSaleCount = styled.p`
  text-align: center;
`;

const WithMiniCartItem: any = withTheme(MiniCartItem);
export { WithMiniCartItem as MiniCartItem };
